import { render, staticRenderFns } from "./AddTeamMemberModal.vue?vue&type=template&id=0faf0078&scoped=true"
import script from "./AddTeamMemberModal.vue?vue&type=script&lang=js"
export * from "./AddTeamMemberModal.vue?vue&type=script&lang=js"
import style0 from "./AddTeamMemberModal.vue?vue&type=style&index=0&id=0faf0078&prod&lang=scss&scoped=true"
import style1 from "./AddTeamMemberModal.vue?vue&type=style&index=1&id=0faf0078&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf0078",
  null
  
)

export default component.exports